export default __webpack_public_path__ + "static/media/immoPoints.0d04c46e.svg";